import { graphql } from "gql.tada";

export const DELETE_CALCULATION = graphql(`
  mutation DeleteCalculation($id: ID!) {
    deleteCalculation(id: $id)
  }
`);

export const CREATE_CALCULATION = graphql(`
  mutation CreateCalculation($input: CreateCalculationInput!) {
    createCalculation(input: $input) {
      id
      name
      kamName
      line
      startDate
      endDate
      supplierId
      supplierName
      status
      createdAt
      updatedAt
      version
    }
  }
`);
